import React from 'react'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import EntityFormDateField from './EntityFormDateField'
import Field = com.eidu.entity.field.Field

export type EntityFormDateInputProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  updateField: (value: DraftFieldValue) => void
  error: boolean
  loading?: boolean
  disabled?: boolean
  dropdownWithinPortal?: boolean
}

const EntityFormDateInput = ({
  field,
  fieldValue,
  updateField,
  error,
  loading = false,
  disabled = false,
  dropdownWithinPortal = true,
}: EntityFormDateInputProps) => (
  <EntityFormDateField
    field={field}
    fieldValue={fieldValue}
    updateField={updateField}
    error={error}
    loading={loading}
    disabled={disabled}
    dropdownWithinPortal={dropdownWithinPortal}
  />
)

export default EntityFormDateInput
